export default "__VITE_ASSET__a82ecf93__"